module.exports = __webpack_public_path__ + "static/media/bg_login@2x.1ba5e9fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/bg/bg_login@2x.jpg
// module id = 316
// module chunks = 0